import React, { useEffect, useState, useRef } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { LoginResponse } from "../../../models/index";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from "primereact/skeleton";
import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { Divider } from 'primereact/divider';
import { utils } from "../../../utils/index";
import { t } from "i18next";
import EventEmitter, { Events } from "../../../services/eventemitter";

const HourWiseChats = () => {
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse
    const fDate = new Date();
    fDate.setDate(fDate.getDate() - 5);
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedCompanyName, setSelectedCompanyName] = useState<any>(null);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [selectedTimeZone, setSelectedTimeZone] = useState<any>(null);
    const [TimeArray, setTimeArray] = useState<any>([])
    const [timeloading, setTimeLoading] = useState(true)
    const [defaultTime, setDefaultTime] = useState<any>(null);
    const timeZoneRef = useRef<any>(null);
    const [hourwiseChat, sethourwiseChat] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [exportloading, setExportLoading] = useState(false)
    const [refreshState, setRefreshState] = useState<any>(new Date())
    const [hidebutton, setHideButton] = useState(true)
    useEffect(() => {
        EventEmitter.on(Events.changelayOutMode, toggleDarkMode);
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])
    const toggleDarkMode = () => {
        setRefreshState(new Date()?.getTime())
    }
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }
    useEffect(() => {
        ApiCalls()
    }, [])

    useEffect(() => {
        timeZone()
    }, [selectedWebsite])
    const skeletonLength = [
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
    ]
    const ApiCalls = async () => {
        timeZone()
    };

    const timeZone = async () => {
        let apiResponse = await wglcsApiService.GetAllReportingTimeZones();
        if (apiResponse) {
            setTimeLoading(false)
            var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
            setTimeArray(apiResponse.data)
            setSelectedTimeZone(data[0])
            setDefaultTime(data[0])
        }
    }
    const onTimeChange = (e) => {
        setSelectedTimeZone(e.value);
    }
    const commonRequestData = () => {
        return {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: "",
            websiteId: "",
            timeZone: selectedTimeZone?.standardName,
            timeType: "",
            agentId: 0,
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
        };
    };
    const fromData = (e) => {
        setFromDate(e.value)
    }
    const toData = (e) => {
        setToDate(e.value)
    }
    const weekbillablechats = hourwiseChat?.weekdayPerChatCount?.filter(f => f.chatType === "Billable").map(m => m.chats)
    const weekdaynotbillablechats = hourwiseChat?.weekdayPerChatCount?.filter(f => f.chatType === "Not Billable").map(m => m.chats)
    const weekendbillablechats = hourwiseChat?.weekendPerChatCount?.filter(f => f.chatType === "Billable").map(m => m.chats)
    const weekenddaynotbillablechats = hourwiseChat?.weekendPerChatCount?.filter(f => f.chatType === "Not Billable").map(m => m.chats)
    const weekhous = hourwiseChat?.weekdayPerChatCount?.map(m => m.hourNo)
    const weekendhous = hourwiseChat?.weekendPerChatCount?.map(m => m.hourNo)
    const hasWeekendData = hourwiseChat?.weekendPerChatCount?.length > 0
    const hasWeekData = hourwiseChat?.weekdayPerChatCount?.length > 0

    const WeekendOptions = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.HourWiseChats-WeekEnds'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('From') + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY"),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: weekendhous,
            title: {
                text: t('ReportComponent.Hours'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Chat-Counts'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            //valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.25,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.BillableChats-WeekEnd'),
            data: weekendbillablechats?.length > 0 ? weekendbillablechats : Array(weekendhous?.length).fill(0),
            color: '#4e86c7'
        },
        {

            name: t('GraphReports-label.NonBillableChats-WeekEnd'),
            data: weekenddaynotbillablechats?.length > 0 ? weekenddaynotbillablechats : Array(weekendhous?.length).fill(0),
            color: '#99A3A4'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const WeekOptions = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.HourWiseChats-WeekDays'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('From') + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY"),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: weekhous,
            title: {
                text: t('ReportComponent.Hours'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Chat-Counts'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            //valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.25,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.BillableChats-WeekDays'),
            data: weekbillablechats?.length > 0 ? weekbillablechats : Array(weekhous?.length).fill(0),
            color: '#4e86c7'
        },
        {
            name: t('GraphReports-label.NonBillableChats-WeekDays'),
            data: weekdaynotbillablechats?.length > 0 ? weekdaynotbillablechats : Array(weekhous?.length).fill(0),
            color: '#99A3A4'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }

    const ExportPDF = async () => {
        setExportLoading(true)
        const element = document.getElementById('hourwiseChat-report');
        if (element) {
            const pdf = new jsPDF();

            // Add the image to the PDF
            const logoWidth = 45;
            const logoHeight = 15;
            const logoY = 5;
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const centerX = (pdfWidth - logoWidth) / 2;

            const imageElement = document.getElementById('logoImage');
            const imgDataUrl = imageElement?.getAttribute('src') || ''; // Get the image source URL
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (ctx) {
                // Draw the image onto the canvas
                const img = new Image();
                img.src = imgDataUrl;
                await new Promise(resolve => {
                    img.onload = () => {
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        resolve(null);
                    };
                });

                // Add the HTML content to the PDF
                const canvasContent = await html2canvas(element);
                const imgContentData = canvasContent.toDataURL('image/png');
                pdf.addImage(imgContentData, 'PNG', 5, 30, 200, 150);

                // Add the logo image to the PDF
                const imgData = canvas.toDataURL('image/svg');
                pdf.addImage(imgData, 'SVG', centerX, logoY, logoWidth, logoHeight);
                pdf.save('Hour Wise Chat.pdf');
            }
        }
        setExportLoading(false)
    };
    const HourwiseChatAPI = async () => {
        var result = await wglcsApiService.hourwisechatsreport(commonRequestData())
        if (result.data.data) {
            sethourwiseChat(result.data.data)
            setLoading(false)
        }
    }
    const submit = () => {
        setLoading(true)
        HourwiseChatAPI()
        setHideButton(false)
    }
    const TimeTemplate = (option) => {
        if (timeloading) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.displayName}</div>
                </div>
            );
        }
    };

    const renderLoader = () => {
        return (
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE" style={{ height: "20px", width: "20px", marginTop: "2px" }} animationDuration=".5s" />
          
        );
    }
    return (
        <div >
            <div className="row p-2">
                <img id="logoImage" style={{ display: "none" }} src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" />
                <div className="wgreport-tab viewreport-box">
                    <div className="row view-wgreport ">
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                            <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                maxDate={new Date()}
                            />
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                            <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                maxDate={new Date()}
                                minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                            />
                        </div>
                        <div className="col-md-3 col-lg-3  py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ManagePoc-DataTable.Time-Zone')}</label>
                            <div className="spinner-box">
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="displayName"
                                value={selectedTimeZone}
                                options={TimeArray}
                                onChange={onTimeChange}
                                optionLabel="displayName"
                                // itemTemplate={TimeTemplate}
                                placeholder={!timeloading ? t('ManagePoc-DataTable.Select-TimeZone') : selectedTimeZone}
                            //  ref={timeZoneRef}
                            />
                            {timeloading && renderLoader()}
                            </div>
                        </div>

                        <div className="col-md-3 py-1 text-right text-md-left">
                            {hidebutton == false ? <>  <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => ExportPDF()}> <Ripple />{exportloading ?
                                <ProgressSpinner
                                    style={{ width: "25px", bottom: "8px" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                /> : t('wg-buttons.Export-PDF')}</button>
                            </> : ""}
                            <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row" id="hourwiseChat-report">
                {loading == true ?
                    <ProgressSpinner
                        style={{ width: "50px", position: "relative", top: "10rem" }}
                        strokeWidth="3"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                    : ""}
                {hourwiseChat.length != 0 && loading == false ? <>
                    <div className="col-md-12">
                        <div className="card" style={{ width: "100%" }}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={WeekOptions}
                            />
                            {!hasWeekData ? <h6 className="wgreport_heading" style={{ position: "absolute", bottom: "55%", left: "40%" }}>{t('GraphReports-label.NoData-Display')}</h6> : ""}
                        </div>
                    </div>
                    <Divider />
                    <div className="col-md-12">
                        <div className="card" style={{ width: "100%" }}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={WeekendOptions}
                            />
                            {!hasWeekendData ? <h6 className="wgreport_heading" style={{ position: "absolute", bottom: "55%", left: "40%" }}>{t('GraphReports-label.NoData-Display')}</h6> : ""}
                        </div>
                    </div>
                </> : ""}
            </div>
        </div>
    )
}
export default HourWiseChats;